import type { ReactNode } from 'react';

import { Card } from '../../shared/ui/primitives';
import { Logo } from '../../shared/ui/Logo';

/** Общая раскладка страниц входа / восстановления пароля. */
export function AuthShell({ subtitle, children }: { subtitle: string; children: ReactNode }) {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-10">
      <div className="w-full max-w-sm space-y-6">
        <div className="flex flex-col items-center gap-3 text-center">
          <Logo size="lg" className="flex-col gap-2" />
          <p className="text-sm text-muted">{subtitle}</p>
        </div>
        <Card className="p-6">{children}</Card>
      </div>
    </div>
  );
}
